const { createContext } = require("react");

const WellsContext = createContext(null);

export default WellsContext;